'use client'; // Error components must be Client components

import { Button } from '@/components/core/Button/Button';
import { ObjectValues } from '@/utils/types';
import { useTranslation } from '@app/i18n/client';
import Link from 'next/link';

const ERROR_DIGESTS_TYPES = {
	NO_PERMISSIONS: 'NO_PERMISSIONS',
	UNKNOWN: 'UNKNOWN',
} as const;

const errorDigestToType: Record<string, ObjectValues<typeof ERROR_DIGESTS_TYPES> | undefined> = {
	'4052242416': ERROR_DIGESTS_TYPES.NO_PERMISSIONS,
};

interface IErrorProps {
	error: Error & { digest: string };
	reset: () => void;
}

export default function Error({ error, reset }: IErrorProps) {
	const { t } = useTranslation();
	const errorType = errorDigestToType[error.digest] ?? ERROR_DIGESTS_TYPES.UNKNOWN;

	return (
		<div className="mx-auto max-w-5xl px-4">
			{errorType === ERROR_DIGESTS_TYPES.NO_PERMISSIONS && (
				<>
					<h2 className="mb-4 text-2xl font-semibold">Something went wrong!</h2>
					<p className="mb-12 max-w-3xl text-xl text-gray-500">
						Looks like you have no permissions right now. Please contact someone from{' '}
						<Link className="underline" href="https://slack.com/app_redirect?channel=C04HY6XCLVB" target="_blank">
							#js-revisor
						</Link>{' '}
						for help.
					</p>
				</>
			)}

			{errorType === ERROR_DIGESTS_TYPES.UNKNOWN && (
				<>
					<h2 className="mb-4 text-2xl font-semibold">Something went wrong!</h2>
					<p className="mb-12 max-w-3xl text-xl text-gray-500">
						An unknown error happened. Please contact someone from{' '}
						<Link className="underline" href="https://slack.com/app_redirect?channel=C04HY6XCLVB" target="_blank">
							#js-revisor
						</Link>{' '}
						for help. [{error.digest}]
					</p>
				</>
			)}

			<Button onClick={reset} size="lg">
				{t('global.retry')}
			</Button>
		</div>
	);
}
